// import React, { useRef, useState, useEffect } from "react";
import React from "react";
import { styled } from "@mui/system";
import { Grid, Box } from "@mui/material";
import Footer from "../components/Shared/Footer";
import Navbar from "../components/NavBar/Navbar";
import HeroLeft from "../components/Home_Page/HeroLeft";
// import useGetSiteImage from  "../hooks/useGetSiteImage";
// import { zoom } from "@mui/material";

const GridContainerMain = styled(Grid)({
  paddingLeft: "0px",
  paddingRight: "0px",
  paddingTop: "0px",
  minHeight: "100vh",
  "@media (max-width: 1400px)": {
      minHeight: "80vh",
  },
});

function Home() {
  // const backgroundImageURL = 'background.png';
  // const { imageURL, error } = useGetSiteImage(backgroundImageURL);





  // const [gridHeight, setGridHeight] = useState(0);
  // const gridRef = useRef(null);
  // const updateHeights = () => {
  //   if (gridRef.current) {
  //     setGridHeight(gridRef.current.clientHeight);
  //   }
  // };

  // useEffect(() => {
  //   window.addEventListener("resize", updateHeights);

  //   updateHeights();

  //   return () => {
  //     window.removeEventListener("resize", updateHeights);
  //   };
  // }, []);

  // const CustomImage = styled("iframe")({
  //   position: "absolute",
  //   top: "400px",
  //   maxWidth: "100vw",
  //   right: "0",
  //   width: "55%",
  //   height: "450px", 
  //   "@media (max-width: 900px)": {
  //     width: "95%",
  //     height: "450px",
  //     top: `${gridHeight}px`,
  //     marginTop: "25%",
  //   },
  // });

  // const CustomImage = styled("img")({
  //   position: "absolute",
  //   top: "400px",
  //   maxWidth: "100vw",
  //   right: "0",
  //   width: "55%",
  //   height: "auto",
  //   "@media (max-width: 900px)": {
  //     width: "95%",
  //     height: "auto",
  //     top: `${gridHeight}px`,
  //     marginTop: "25%",
  //   },
  // });

  return (
    <div style={{background: "linear-gradient(to bottom, rgba(209, 207, 207, 0.9), rgba(255, 255, 255, 0.9))"}}>
    <Box sx={{
      position: 'relative',
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: '100vh',
        backgroundImage: `url(${process.env.REACT_APP_CLIENT_URL}/images/background.png)`,
        // backgroundImage: `url(${!error ? imageURL : ""})`,
        backgroundSize: {
          xs: '300% 80%',
          sm: '230% 80%',
          md: '150% 80%',
          lg: 'cover',
        },
        backgroundPosition: 'bottom center',
        backgroundRepeat: 'no-repeat',
        zIndex: -1
      }
    }}>
    
      <Navbar />
      <GridContainerMain
        container
        sx={{
          paddingBottom: {
            xs: "0px",
            sm: "150px",
            md: "100px",
            lg: "100px",
            xl: "300px",
          },
        }}
      >
        {/* HeroLeft */}
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{zIndex: 1}}>
          <HeroLeft />
        </Grid>

        {/* HeroRight */}
        {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Grid container spacing={0}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Zoom in={true} timeout={600}>
                <CustomImage
                  src={
                    process.env.REACT_APP_CLIENT_URL + "/images/HomepageAnimation.png"
                  }
                  alt="Home Page"
                />
                <CustomImage
                  src={
                    "https://player.webcamera.pl/skywind_cam_772102?autoplay=1&mute=1"
                  }
                  alt="Home Page"
                />
              </Zoom>
            </Grid>
          </Grid>
        </Grid> */}

        {/* Feature Section
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}
          sx={{
            paddingLeft: { xs: "5%", sm: "10%", md: "10%", lg: "15%", xl: "20%" },
            paddingRight: { xs: "5%", sm: "10%", md: "10%", lg: "15%", xl: "20%" },
            paddingTop: "25%",
            "@media (max-width: 900px)": {
              paddingTop: "95%",
            },
          }}
        /> */}

      </GridContainerMain>
      <Footer />
    </Box>
    </div>
  );
}

export default Home;